var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAlignmentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4576_70622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60494 24L36.3951 24C38.386 24 40 21.8925 40 19.2927V4.70726C40 2.10751 38.386 0 36.3951 0L3.60494 0C1.61399 0 0 2.10751 0 4.70726V19.2927C0 21.8925 1.61399 24 3.60494 24Z",
    fill: "#C9CACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23845 20.3145L33.7611 20.3145C35.3703 20.3145 36.6748 18.6111 36.6748 16.5098V7.49066C36.6748 5.38943 35.3703 3.68604 33.7611 3.68604L6.23845 3.68604C4.62927 3.68604 3.32477 5.38943 3.32477 7.49066V16.5098C3.32477 18.6111 4.62927 20.3145 6.23845 20.3145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8214 18.6027H25.6591C24.4874 18.6013 23.3642 18.1617 22.5358 17.3801C21.7074 16.5986 21.2415 15.539 21.2402 14.4339V9.56457C21.2417 8.45956 21.7077 7.40018 22.5361 6.61882C23.3644 5.83746 24.4876 5.39783 25.6591 5.39648H30.8214C31.993 5.39764 33.1162 5.83724 33.9446 6.61864C34.7731 7.40005 35.239 8.4595 35.2402 9.56457V14.4339C35.2392 15.5391 34.7734 16.5988 33.9449 17.3803C33.1165 18.1619 31.9931 18.6015 30.8214 18.6027ZM25.6591 6.12396C24.6915 6.12454 23.7637 6.4873 23.0794 7.13249C22.3951 7.77768 22.0102 8.65265 22.0092 9.56528V14.4346C22.01 15.3471 22.3946 16.2221 23.0786 16.8674C23.7626 17.5127 24.6901 17.8756 25.6575 17.8766H30.8199C31.7873 17.8756 32.7148 17.5127 33.3988 16.8674C34.0828 16.2221 34.4674 15.3471 34.4682 14.4346V9.56528C34.4672 8.6529 34.0825 7.77817 33.3985 7.13302C32.7145 6.48787 31.7872 6.12492 30.8199 6.12396H25.6591Z",
    fill: "#717273"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4576_70622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAlignmentRight);
export default __webpack_public_path__ + "static/media/active-alignment-right.67b3505eb80af2d20b0671c0b5827891.svg";
export { ForwardRef as ReactComponent };